export const SupportStatus = {
    PROCESSING:"در حال انجام",
    AWAITING_USER:"پاسخ داده شد",
    AWAITING_EXPERT:"در انتظار کارشناس",
    COMPLETE:"تکمیل شده",
    CANCEL:"لغو شده"
}
